import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminDataManagement } from '@totem/components/ui_components/menus/mainMenu/admin_dataMgmt';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const DataManagementPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard>
        <TabContentMenu items={getMenuAdminDataManagement(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default DataManagementPage;
